export const NOTIFICATION_EVENTS = [
  {
    id: 'registration',
    label: 'ثبت‌نام کاربر',
    description: 'پس از ساخته‌شدن حساب جدید',
    category: 'account',
  },
  {
    id: 'contactMessageSubmitted',
    label: 'دریافت پیام تماس',
    description: 'پس از ثبت موفق فرم تماس با ما',
    category: 'communications',
  },
  {
    id: 'orderCreated',
    label: 'ثبت سفارش',
    description: 'پس از ایجاد یک سفارش جدید',
    category: 'store',
  },
  {
    id: 'paymentSuccess',
    label: 'پرداخت موفق',
    description: 'پس از تأیید تراکنش بانکی',
    category: 'store',
  },
  {
    id: 'paymentFailed',
    label: 'پرداخت ناموفق',
    description: 'پس از رد یا ناقص‌ماندن تراکنش',
    category: 'store',
  },
  {
    id: 'orderStatusChanged',
    label: 'تغییر وضعیت سفارش',
    description: 'پس از تغییر وضعیت توسط مدیر',
    category: 'store',
  },
  {
    id: 'reviewSubmitted',
    label: 'ثبت نظر محصول',
    description: 'پس از ارسال یا ویرایش نظر توسط کاربر',
    category: 'store',
  },
  {
    id: 'reviewReplied',
    label: 'پاسخ به نظر محصول',
    description: 'پس از ثبت یا ویرایش پاسخ مدیر برای کاربر',
    category: 'store',
  },
  {
    id: 'serviceOrderCreated',
    label: 'ثبت سفارش خدمات',
    description: 'پس از ارسال فرم انتخاب پلن',
    category: 'services',
  },
  {
    id: 'serviceQuoteReady',
    label: 'آماده‌شدن پیشنهاد خدمات',
    description: 'پس از ارسال قیمت نهایی توسط مدیر',
    category: 'services',
  },
  {
    id: 'serviceOrderStatusChanged',
    label: 'تغییر وضعیت سفارش خدمات',
    description: 'هنگام تغییر مرحله اجرای پروژه',
    category: 'services',
  },
  {
    id: 'servicePaymentSuccess',
    label: 'پرداخت موفق خدمات',
    description: 'پس از پرداخت پیشنهاد قیمت',
    category: 'services',
  },
  {
    id: 'servicePaymentFailed',
    label: 'پرداخت ناموفق خدمات',
    description: 'پس از ناقص‌ماندن پرداخت خدمات',
    category: 'services',
  },
];

export const NOTIFICATION_CATEGORIES = [
  { id: 'all', label: 'همه' },
  { id: 'account', label: 'حساب کاربری' },
  { id: 'communications', label: 'ارتباطات' },
  { id: 'store', label: 'فروشگاه' },
  { id: 'services', label: 'خدمات' },
];

export const eventHasActiveChannel = (event = {}) => (
  Boolean(
    event.emailEnabled
    || event.smsEnabled
    || event.adminEmailEnabled
    || event.adminSmsEnabled
  )
);

export const filterNotificationEvents = (
  events = {},
  { query = '', category = 'all', onlyActive = false } = {}
) => {
  const normalizedQuery = String(query).trim().toLocaleLowerCase('fa');

  return NOTIFICATION_EVENTS.filter((item) => {
    if (category !== 'all' && item.category !== category) return false;
    if (onlyActive && !eventHasActiveChannel(events[item.id])) return false;
    if (!normalizedQuery) return true;
    return `${item.label} ${item.description}`
      .toLocaleLowerCase('fa')
      .includes(normalizedQuery);
  });
};

export const getNotificationSummary = (events = {}) => (
  NOTIFICATION_EVENTS.reduce((summary, item) => {
    const event = events[item.id] || {};
    if (eventHasActiveChannel(event)) summary.activeEvents += 1;
    if (event.emailEnabled || event.adminEmailEnabled) summary.emailEvents += 1;
    if (event.smsEnabled || event.adminSmsEnabled) summary.smsEvents += 1;
    return summary;
  }, {
    totalEvents: NOTIFICATION_EVENTS.length,
    activeEvents: 0,
    emailEvents: 0,
    smsEvents: 0,
  })
);

export const getAdminRecipientSummary = (users = []) => {
  const administrators = users.filter(
    (user) => String(user?.role || '').trim().toLowerCase() === 'admin'
  );
  const hasValue = (value) => Boolean(String(value || '').trim());

  return {
    total: administrators.length,
    withEmail: administrators.filter((administrator) => hasValue(administrator.email)).length,
    withPhone: administrators.filter((administrator) => hasValue(administrator.phone)).length,
  };
};
